import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest, apiGetRequest } from "utils/api";

interface AddCategoryParams {
  category: string;
  loan_type: string;
}

export function useCategories() {
  const queryClient = useQueryClient();

  const { data: categories = [], isLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const { categories = [] } = await apiGetRequest<{
        categories: string[];
      }>("/supabase/categories/select");
      return categories;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const addCategory = useMutation({
    mutationFn: async (params: AddCategoryParams) => {
      const { category: newCategory } = await apiRequest<{
        category: string;
      }>("/supabase/categories/insert", params);
      return newCategory;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });

  return {
    categories,
    isLoading,
    addCategory: addCategory.mutateAsync,
  };
}
